import type { Artifact } from "@/services/api/agentic-v2";
import { artifactReportViewerUrl } from "@/components/artifacts/artifactReportViewer";
import { isLoaArtifact } from "./clientDisplay";

export type PlanArtifactRole = "loa" | "cheatSheet";

export type PlanArtifactActionKind =
  | "view"
  | "edit"
  | "editDocument"
  | "preview"
  | "document";

export interface PlanArtifactResolvedAction {
  kind: PlanArtifactActionKind;
  label: string;
  href?: string;
}

export interface PlanArtifactActionLabels {
  view?: string;
  preview?: string;
  edit?: string;
}

/** Resolve plan-row actions for an LOA or cheat-sheet artefact. */
export function resolvePlanArtifactActions(
  artifact: Artifact,
  labels: PlanArtifactActionLabels,
  role: PlanArtifactRole,
): PlanArtifactResolvedAction[] {
  return role === "loa"
    ? resolveLoaActions(artifact, labels)
    : resolveCheatSheetActions(artifact, labels);
}

function resolveLoaActions(
  artifact: Artifact,
  labels: PlanArtifactActionLabels,
): PlanArtifactResolvedAction[] {
  const actions: PlanArtifactResolvedAction[] = [];

  if (isLoaArtifact(artifact) && artifact.kind === "react_form") {
    actions.push({
      kind: "preview",
      label: labels.preview ?? "Preview LOA",
      href: `/loa-preview/${artifact._id}`,
    });
  }

  actions.push({
    kind: "editDocument",
    label: labels.edit ?? "Edit LOA",
  });

  return actions;
}

function resolveCheatSheetActions(
  artifact: Artifact,
  labels: PlanArtifactActionLabels,
): PlanArtifactResolvedAction[] {
  const actions: PlanArtifactResolvedAction[] = [];
  const viewerUrl = artifactReportViewerUrl(artifact);

  if (viewerUrl) {
    actions.push({
      kind: "view",
      label: labels.view ?? "View cheat sheet",
      href: viewerUrl,
    });
  }

  const reportBuilderId = artifact.storage?.report_builder?.report_id ?? null;
  if (reportBuilderId) {
    actions.push({
      kind: "edit",
      label: labels.edit ?? "Edit cheat sheet",
    });
  }

  if (actions.length === 0) {
    actions.push({
      kind: "document",
      label: labels.view ?? "View cheat sheet",
    });
  }

  return actions;
}
